import styled from 'styled-components';
import media from 'src/styles/Media.styled';

export const MainContainer = styled.div`
    display: flex;
    align-content: 'left';
    color: #140f4b;
    ${media.mobileDevice`
        background-color: 'red';
    `};
`;

export const EditImage = styled.p`
    display: flex;
    font-weight: bold;
    font-size: 10px;
`;

export const ReviewContainer = styled.div`
    display: inline-flex;
    width: 100%;
    ${media.mobileDevice`
        flex-direction:column;
        justify-content: space-between;
        margin: 0px;
    `}
`;
export const SignatureTitle = styled.span`
    font-weight: bold;
    line-height: 28px;
    display: flex;
    font-size: 10px;
`;

export const ContractTitle = styled.p`
    font-weight: bold;
    line-height: 28px;
    display: flex;
    font-size: 10px;
    color: #202124;
`;

export const Data = styled.div`
    font-family: ${({ fontFamily }) =>
        fontFamily ? fontFamily : 'AvenirNextWorld Demi'};
    color: ${({ color }) => (color ? color : '#202124')};
    font-size: ${({ fontSize }) => (fontSize ? fontSize : '15px')};
    ${media.mobileDevice`
    margin: ${({ margin }) => (margin ? margin : '')};
    `}
`;

export const StyledDiv = styled.div`
    width: ${({ desktopWidth }) => (desktopWidth ? desktopWidth : '100%')};
    display: ${({ desktopDisplay }) => (desktopDisplay ? desktopDisplay : '')};
    justify-content: ${({ desktopJustifyContent }) =>
        desktopJustifyContent ? desktopJustifyContent : ''};
    ${media.mobileDevice`
           width:  ${({ width }) => (width ? width : '100%')};
           display: ${({ display }) => (display ? display : '')} ;
           justify-content: ${({ justifyContent }) =>
               justifyContent ? justifyContent : ''} ;
           
    `}
`;

export const LineSeparator = styled.hr`
    display: none;
    ${media.mobileDevice`
    border: 0;
    border-top: 2px solid #e8e8e8;
    box-sizing: content-box;
    height: 0;
    overflow: visible;
    display: flex;
    `}
`;
